import { RouterStateSerializer } from '@ngrx/router-store';
import { EcnRouteData } from 'app/models/route';
import { EcnRouterReducerState } from 'app/models/reducers/router';
import { ActivatedRouteSnapshot, Params, RouterStateSnapshot } from '@angular/router';
import { ArrayUtils } from '@festo-ax/smartenance-shared-ui';

export class MergedRouteSerializer implements RouterStateSerializer<EcnRouterReducerState> {
  private previousUrl: string | null = null;

  serialize(routerState: RouterStateSnapshot): EcnRouterReducerState {
    // we add asset outlet params to primary outlet params
    const assetParams: Params = getOutletParams(routerState, 'asset');
    const assetData: Params = getOutletParams(routerState, 'asset', r => r.data);

    const url: string = routerState.url;
    const previousUrl: string|null = this.previousUrl;
    // Capture previous url for next request
    this.previousUrl = url;

    return {
      url,
      previousUrl,
      params: {
        ...mergeRouteParams(routerState.root, r => r.params),
        ...assetParams,
      },
      queryParams: mergeRouteParams(routerState.root, r => r.queryParams),
      data: {
        ...mergeRouteData(routerState.root),
        ...assetData
      },
    };
  }
}

function getOutletParams(
  routerState: RouterStateSnapshot,
  outletName: string,
  getter: (r: ActivatedRouteSnapshot) => Params = (r): Params => r.params
): Params {
  let assetParams: Params = {};

  if (ArrayUtils.isNotEmpty(routerState.root?.children)) {
    for (const child of routerState.root.children) {
      assetParams = { ...assetParams, ...mergeRouteParams(child, getter, outletName) };
    }
  }

  return assetParams;
}

function mergeRouteParams(route: ActivatedRouteSnapshot, getter: (r: ActivatedRouteSnapshot) => Params, outletName = 'primary'): Params {
  if (!route) {
    return {};
  }

  const currentParams = getter(route);
  const primaryChild = route.children?.find(c => c.outlet === outletName) || route.firstChild;
  return {...currentParams, ...mergeRouteParams(primaryChild, getter)};
}

function mergeRouteData(route: ActivatedRouteSnapshot, outletName: string = 'primary'): EcnRouteData {
  if (!route) {
    return {};
  }

  const currentData = route.data;
  const primaryChild = route.children?.find(c => c.outlet === outletName) || route.firstChild;
  return {...currentData, ...mergeRouteData(primaryChild)};
}
